import React from 'react'
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';

import { MODULE_CONFIG } from '../../../../../../../data/config/urls';
import { HANDLING_ALERT } from '../../../../../../../data/config/constants'


class Timer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.timer = null;
    this.state = {
      time: {
        hours: 0,
        minutes: 0,
        seconds: 0,
      }
    }
  }

  componentDidMount() {
    const { timestamp, pending_timer, handling_timer, bot_timer } = this.props;
    if (timestamp)
      if (pending_timer)
        this.timer = setInterval(this.setPendingTime, 1000);
      else if (handling_timer)
        this.timer = setInterval(this.setHandlingTime, 1000);
      else if (bot_timer)
        this.timer = setInterval(this.setBotTime, 1000);
  }

  componentDidUpdate(prevProps) {
    const { timestamp, pending_timer, handling_timer, bot_timer } = this.props;
    if (prevProps.timestamp !== timestamp) {
      if (this.timer)
        clearInterval(this.timer)
      if (pending_timer)
        this.timer = setInterval(this.setPendingTime, 1000);
      else if (handling_timer)
        this.timer = setInterval(this.setHandlingTime, 1000);
      else if (bot_timer)
        this.timer = setInterval(this.setBotTime, 1000);
    }
  }

  componentWillUnmount() {
    if (this.timer)
      clearInterval(this.timer);
  }

  setPendingTime = () => {
    const { timestamp, onPendingTimeout } = this.props;
    const now = new Date().getTime();
    const distance = timestamp - now;
    if (distance < 0) {
      clearInterval(this.timer);
      this.setState({
        time: { minutes: 0, seconds: 0 }
      }, onPendingTimeout)
    } else {
      this.setState({
        time: {
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        }
      })
    }
  };

  setHandlingTime = () => {
    const { timestamp, onChangeHandlingTimeAlert } = this.props;
    const now = new Date().getTime();
    const distance = now - timestamp;
    if (distance >= 0) {
      this.setState({
        time: {
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        }
      });
    }
    if (onChangeHandlingTimeAlert) {
      if ((MODULE_CONFIG.CHATS.LONG_CHAT_HANDLING_TIME <= distance) && (distance < MODULE_CONFIG.CHATS.CRITICAL_CHAT_HANDLING_TIME))
        onChangeHandlingTimeAlert(HANDLING_ALERT.LONG)
      else if (MODULE_CONFIG.CHATS.CRITICAL_CHAT_HANDLING_TIME <= distance)
        onChangeHandlingTimeAlert(HANDLING_ALERT.CRITICAL)
    }
  };

  setBotTime = () => {
    const { timestamp, need_attention_time } = this.props;
    const distance = need_attention_time && need_attention_time !== "" ? (need_attention_time - timestamp) : (new Date().getTime() - timestamp);
    if (distance >= 0) {
      this.setState({
        time: {
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        }
      });
    } else
      clearInterval(this.timer);
  };

  render() {
    const { tooltip_title, class_name, timestamp } = this.props;
    const { time } = this.state;
    if (timestamp)
      return (
        <Tooltip overlayClassName="ori-tooltip-arrow-hidden ori-tooltip-bg-white ori-tooltip-tag" placement="topLeft" title={tooltip_title}>
          <div className={`${class_name} ori-border-radius-4 ori-font-sm ori-lr-pad-3`} >
            <span style={{ lineHeight: '24px' }}>
              {
                time.hours !== undefined &&
                <span className="ori-lr-pad-3">{`${time.hours < 10 ? '0' : ''}${time.hours}`} <span>:</span></span>
              }
              <span className="ori-lr-pad-3">{`${time.minutes < 10 ? '0' : ''}${time.minutes}`} <span>:</span></span>
              <span className="ori-lr-pad-3">{`${time.seconds < 10 ? '0' : ''}${time.seconds}`}</span>
            </span>
          </div>
        </Tooltip>
      );
    return null;
  }
}

Timer.propTypes = {
  timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  need_attention_time: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltip_title: PropTypes.string,
  class_name: PropTypes.string,
  pending_timer: PropTypes.bool,
  handling_timer: PropTypes.bool,
  bot_timer: PropTypes.bool,
  onPendingTimeout: PropTypes.func,
  onChangeHandlingTimeAlert: PropTypes.func
};

Timer.defaultProps = {
  pending_timer: false,
  handling_timer: false,
  bot_timer: false,
  need_attention_time: null,
}

export default Timer;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/chats/components/chatitem/timer/index.js